import { createSlice } from "@reduxjs/toolkit";
// import moment from "moment";
import { momentCustomInstance as moment } from '../../app/common/libs/helper';
import { ConversationType, MessageType } from "../../app/common/constants/values";
import {
    fetchTranscripts,
    fetchConversationBySid,
    fetchConversationMessages,
    fetchConversationRating,
    fetchTranscriptByConversationId,
    sendAllTranscriptHistory,
    sendCurrentTranscriptHistory,
    updateCustomerInfo
} from "./transcriptsAPI";
import { toast } from 'react-toastify';


export const initialState = {
    loading: false,
    error: null,
    totalCount: 0,
    // pageNo:0,
    // pageSize:10,
    // filterState: {
    //     filterBy: '',
    //     filterValue: '',
    //     channelType: null,
    //     rated: null,
    //     status: null
    // },
    data: [],
    transcriptData: {},
    messages: {
        conversation: {},
        conversationRating: {},
        hasNextPage: true,
        isNextPageLoading: false,
        pageNo: 1,
        pageSize: 10,
        items: [],
        total: 0,
        offlineMessages: [],
        previousChatHistory: []
    }
};
const composeMessage = (message, type, outgoingId) => {

    let direction = '';
    if (message.sender.type == MessageType.Customer && message.body && message.body.includes("We're not around")) {
        direction = 'outgoing';
    }
    else if (type == ConversationType.Agent) {
        direction = message.sender.userId == outgoingId ? 'outgoing' : 'incoming';
    }
    else {
        direction = message.sender.type == MessageType.Customer ? 'incoming' : 'outgoing';
    }
    return {
        sid: message.sid,
        username: message.sender.name,
        date: moment(message.dateUpdated).calendar(),
        body: message.body,
        index: message.index,
        incoming: direction == 'incoming' ? true : false,
        direction,
        deliveryReceipt: message.deliveryReceipt,
        datetime: new Date(message.dateUpdated),
        media: message.media ? message.media : null
    };
};
export const transcriptsSlice = createSlice({
    name: "transcripts",
    initialState: initialState,
    reducers: {
        setDate: (state, action) => {
            state.startDate = action.payload.start;
            state.endDate = action.payload.end;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setRatingLoading: (state, action) => {
            let conversation = state.data.find(a => a.conversationSid == action.payload);
            if (conversation) {
                conversation.loading = true;
            }
        },
        setHasRated: (state, action) => {
            let conversation = state.data.find(a => a.conversationSid == action.payload.conversationId);
            if (conversation) {
                conversation.hasRated = true;
            }
        },
        updateConversationCompleteState: (state, action) => {
            const { conversationSid, closedBy, dateClosed } = action.payload;
            if (state.messages.conversation.conversationSid == conversationSid) {
                state.messages.conversation.closedBy = closedBy;
                state.messages.conversation.dateClosed = dateClosed;
            }
        },
        UpdateTranscriptMessages: (state, action) => {
            let direction = '';
            if (action.payload.Sender.Type == MessageType.Customer && action.payload.Body.includes("We're not around")) {
                direction = 'outgoing';
            }
            if (state.messages.conversation.conversationType == ConversationType.Agent) {
                direction = action.payload.Sender.UserId == state.messages.conversation.agentInfo.userId ? 'outgoing' : 'incoming';
            }
            else {
                direction = action.payload.Sender.Type == MessageType.Customer ? 'incoming' : 'outgoing';
            }
            var message = {
                sid: action.payload.Sid,
                username: action.payload.Sender.Name,
                date: moment(action.payload.DateUpdated).calendar(),
                body: action.payload.Body,
                index: action.payload.Index,
                incoming: direction == 'incoming' ? true : false,
                direction,
                deliveryReceipt: action.payload.DeliveryReceipt,
                datetime: new Date(action.payload.DateUpdated)
            };
            if (state.messages.conversation.id == action.payload.ConversationId) {
                state.messages.items.push(message);
                state.messages.total += 1;
            }
            var conv = state.data.find(x => x.id == action.payload.ConversationId);
            if (conv) {
                conv.messageCount += 1;
            }
        }
    },
    extraReducers: {
        [fetchTranscripts.pending]: (state) => {
            state.loading = true;
        },
        [fetchTranscripts.rejected]: (state, { meta, error }) => {
            state.loading = false;
            state.data = [];
            state.error = error;
        },
        [fetchTranscripts.fulfilled]: (state, { meta, payload: { data } }) => {
            state.loading = false;
            state.error = '';
            state.totalCount = data.totalCount;
            state.data = data.transcripts;

            console.log('state.data = data.transcripts')
            console.log(data.transcripts);

            state.data.forEach((element) => {
                element.obtainedRating = element.rating;
                element.ratingLoaded = false;
                element.rating = {
                    feedback: '',
                    avgRatingValue: 0,
                    questions: [{ category: 0, rating: 0 }, { category: 1, rating: 0 }]
                };
            });
        },
        [fetchConversationBySid.pending]: (state) => {
            state.loading = true;
            state.messages.isNextPageLoading = false;
            state.messages.items = [];
            state.messages.total = 0;
            state.messages.hasNextPage = false;
            state.messages.pageNo = 1;
            state.messages.conversation = {};
        },
        [fetchConversationBySid.rejected]: (state) => {
            state.loading = false;
            state.messages.items = [];
            state.messages.conversation = {};
        },
        [fetchConversationBySid.fulfilled]: (state, { meta, payload: { data } }) => {
            state.loading = false;
            state.messages.conversation = data.conversation;
            state.messages.conversation.obtainedRating = data.conversation.rating;

            const messages = state.messages.offlineMessages = data.offlineMessages;
            const previousChatHistory = data.conversation?.customerProfile?.previousChatHistory || [];
            state.messages.previousChatHistory = messages
                .concat(previousChatHistory)
                .sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated));
        },
        [fetchConversationMessages.pending]: (state) => {
            state.messages.isNextPageLoading = true;
        },
        [fetchConversationMessages.rejected]: (state) => {
            state.messages.isNextPageLoading = false;
            state.messages.items = [];
            state.messages.total = 0;
            state.messages.hasNextPage = false;
            state.messages.pageNo = 1;
        },
        [fetchConversationMessages.fulfilled]: (state, { meta, payload: { data } }) => {
            let { messages, totalCount } = data;
            messages = messages.reverse().map(x => composeMessage(x, state.messages.conversation.conversationType, state.messages.conversation.agentInfo?.userId));
            let result = [...messages, ...state.messages.items];
            const hasNextPage = messages.length == 0 ? false : result.length < totalCount ? true : false;
            let pageNo = hasNextPage ? state.messages.pageNo + 1 : state.messages.pageNo;
            state.messages.isNextPageLoading = false;
            state.messages.items = result;
            state.messages.total = totalCount;
            state.messages.hasNextPage = hasNextPage;
            state.messages.pageNo = pageNo;
        },
        [fetchConversationRating.pending]: (state) => {
            // set conversation rating
            state.messages.conversationRating.ratingLoaded = false;
            state.messages.conversationRating.rating = {
                feedback: '',
                avgRatingValue: 0,
                questions: [
                    { category: 0, rating: 0 },
                    { category: 1, rating: 0 },
                ],
            };
        },
        [fetchConversationRating.rejected]: (state, { meta, error }) => {
            let conversation = state.data.find(a => a.conversationSid == meta.arg);
            if (conversation) {
                conversation.ratingLoaded = false;
            }
            toast.error(`${meta.arg} ' : Unable to get rating...!`);
        },
        [fetchConversationRating.fulfilled]: (state, { meta, payload: { data } }) => {
            console.log('fetchConversationRating : ' + meta.arg);

            let { conversationSid: sessionId, questions, avgRatingValue, feedback } = data;
            let conversation = state.data.find(a => a.conversationSid == meta.arg);

            // set conversation rating
            state.messages.conversationRating.ratingLoaded = true;
            state.messages.conversationRating.rating = {
                questions, avgRatingValue, feedback
            };

            // Set Conversation rating in transcriptData
            state.transcriptData.ratingLoaded = true;
            state.transcriptData.rating = {
                questions, avgRatingValue, feedback
            };

            if (conversation) {
                console.log('fetchConversationRating updating : ' + conversation.id);
                conversation.ratingLoaded = true;
                conversation.rating = {
                    questions, avgRatingValue, feedback
                };
            }
        },
        [fetchTranscriptByConversationId.pending]: (state) => {
            state.loading = true;
        },
        [fetchTranscriptByConversationId.rejected]: (state, { meta, error }) => {
            state.loading = false;
            state.transcriptData = {};
            state.error = error;
        },
        [fetchTranscriptByConversationId.fulfilled]: (state, { meta, payload: { data } }) => {
            state.loading = false;
            state.error = '';
            state.transcriptData = {
                ...data,
                ratingLoaded: false,
                rating: {
                    feedback: '',
                    avgRatingValue: 0,
                    questions: [
                        { category: 0, rating: 0 },
                        { category: 1, rating: 0 },
                    ],
                },
            };
        },
        [sendCurrentTranscriptHistory.pending]: (state) => {
            state.loading = true;
        },
        [sendCurrentTranscriptHistory.rejected]: (state, { meta, error }) => {
            state.loading = false;
            state.transcriptData = {};
            state.error = error;
        },
        [sendCurrentTranscriptHistory.fulfilled]: (state, { meta, payload: { data } }) => {
            state.loading = false;
            state.error = '';
            toast.success("Transcript sent successfully");
        },
        [sendAllTranscriptHistory.pending]: (state) => {
            state.loading = true;
        },
        [sendAllTranscriptHistory.rejected]: (state, { meta, error }) => {
            state.loading = false;
            state.transcriptData = {};
            state.error = error;
        },
        [sendAllTranscriptHistory.fulfilled]: (state, { meta, payload: { data } }) => {
            state.loading = false;
            state.error = '';
            toast.success("Transcript sent successfully");
        },
        [updateCustomerInfo.pending]: (state) => {
            state.loading = true;
        },
        [updateCustomerInfo.rejected]: (state, { meta, error }) => {
            state.loading = false;
        },
        [updateCustomerInfo.fulfilled]: (state, { meta, payload: { data } }) => {
            state.loading = false;
        },
    },
});
export const { setDate, setRatingLoading, setHasRated, UpdateTranscriptMessages, updateConversationCompleteState, setLoading } = transcriptsSlice.actions;
export default transcriptsSlice.reducer;